/**
 * New PDP only — header mega/drop menu lazy-load + visibility fix.
 */
(function () {
  'use strict';

  if (window.innerWidth < 1024) return;

  function megaMenusNeedContent() {
    var menus = document.querySelectorAll('.t4s-type__mega .t4s-lazy_menu');
    if (!menus.length) return false;

    return Array.prototype.some.call(menus, function (menu) {
      if (menu.querySelector('.t4s-sub-column-item, .type_mn_link, .type_mn_banner')) {
        return false;
      }
      return menu.querySelector('.t4s-loading--bg') || !menu.textContent.trim();
    });
  }

  function dropMenusNeedContent() {
    var menus = document.querySelectorAll('.t4s-type__drop .t4s-lazy_menu[data-handle]');
    if (!menus.length) return false;

    return Array.prototype.some.call(menus, function (menu) {
      if (menu.querySelector('.t4s-menu-item a')) return false;
      return menu.querySelector('.t4s-loading--bg') || !menu.textContent.trim();
    });
  }

  function lazyMenusNeedContent() {
    return megaMenusNeedContent() || dropMenusNeedContent();
  }

  function clearDropSessionCache() {
    try {
      Object.keys(sessionStorage).forEach(function (key) {
        if (key.indexOf('timeDropT4s') === 0 || key.indexOf('dataDropT4s') === 0) {
          sessionStorage.removeItem(key);
        }
      });
    } catch (e) {
      /* ignore */
    }
  }

  function clearMegaSessionCache() {
    try {
      Object.keys(sessionStorage).forEach(function (key) {
        if (key.indexOf('timeMegaT4s') === 0 || key.indexOf('dataMegaT4s') === 0) {
          sessionStorage.removeItem(key);
        }
      });
    } catch (e) {
      /* ignore */
    }
  }

  function positionMegaPanel() {
    var panel = document.getElementById('content_mega_6CtdTq');
    if (!panel) return;

    panel.style.position = 'absolute';
    panel.style.top = '100%';
    panel.style.left = '0';
    panel.style.right = '0';
    panel.style.marginLeft = 'auto';
    panel.style.marginRight = 'auto';
    panel.style.width = '750px';
    panel.style.maxWidth = 'min(750px, calc(100vw - 48px))';
    panel.style.transform = 'none';
  }

  function resetMegaFlexLayout() {
    positionMegaPanel();

    document
      .querySelectorAll('#content_mega_6CtdTq .t4s-sub-column-item')
      .forEach(function (col) {
        col.style.position = 'relative';
        col.style.left = 'auto';
        col.style.top = 'auto';
        col.style.right = 'auto';
        col.style.width = 'auto';
        col.style.maxWidth = 'none';
        col.style.minWidth = '0';
        col.style.transform = 'none';
      });

    var grid = document.querySelector('#content_mega_6CtdTq .t4s-lazy_menu.isotopet4s');
    if (grid) {
      grid.style.height = 'auto';
      grid.style.display = 'grid';
      grid.style.gridTemplateColumns = 'repeat(3, minmax(0, 1fr))';
    }
  }

  function layoutMegaMenus() {
    if (!window.jQuery_T4NT) return;

    jQuery_T4NT('.t4s-type__mega .t4s-lazy_menu.isotopet4s').each(function () {
      var $menu = jQuery_T4NT(this);

      if ($menu.hasClass('isotopet4s-enabled') && typeof $menu.isotopet4s === 'function') {
        try {
          $menu.isotopet4s('destroy');
        } catch (e) {
          /* ignore */
        }
        $menu.removeClass('isotopet4s-enabled');
      }
    });

    resetMegaFlexLayout();
  }

  function initHeaderMenu() {
    if (window.T4SThemeSP && T4SThemeSP.Header) {
      if (typeof T4SThemeSP.Header.init === 'function') {
        T4SThemeSP.Header.init();
      }
      if (typeof T4SThemeSP.Header.stickyInit === 'function') {
        T4SThemeSP.Header.stickyInit();
      }
    }
  }

  function afterMegaUpdate() {
    layoutMegaMenus();

    window.setTimeout(layoutMegaMenus, 100);
    window.setTimeout(layoutMegaMenus, 300);
    window.setTimeout(function () {
      layoutMegaMenus();
      resetMegaFlexLayout();
    }, 800);
  }

  function initHeaderOnce() {
    if (window.__nppHeaderMenuInited) return;
    window.__nppHeaderMenuInited = true;
    initHeaderMenu();
  }

  function injectMegaHtml(combinedHtml) {
    if (!combinedHtml) return;

    var wrapper = document.createElement('div');
    wrapper.innerHTML = combinedHtml;

    document.querySelectorAll('.t4s-type__mega .t4s-lazy_menu').forEach(function (menu) {
      var id = menu.getAttribute('data-id');
      if (!id) return;

      var source = wrapper.querySelector('#t4s-mega-contents' + id);
      if (!source || !source.innerHTML.trim()) return;

      menu.innerHTML = source.innerHTML;
      menu.classList.remove('isotopet4s-later');
    });

    if (window.T4SThemeSP && T4SThemeSP.reinitProductGridItem) {
      T4SThemeSP.reinitProductGridItem();
    }

    afterMegaUpdate();
    bindMegaHover();
    initHeaderOnce();
  }

  function injectDropHtml(html) {
    if (!html || html === 'NVT_94') return;

    var menus = Array.prototype.slice.call(
      document.querySelectorAll('.t4s-type__drop .t4s-lazy_menu[data-handle]')
    );
    if (!menus.length) return;

    var body = String(html).split('[nt_drop_split1]')[1];
    if (!body) return;

    body = body.split('[nt_drop_split1]')[0];
    var chunks = body.split('[nt_drop_split2]');

    menus.forEach(function (menu, index) {
      if (!chunks[index] || !chunks[index].trim()) return;
      menu.innerHTML = chunks[index];
    });
  }

  function fetchDropMenus() {
    var menus = Array.prototype.slice.call(
      document.querySelectorAll('.t4s-type__drop .t4s-lazy_menu[data-handle]')
    );
    if (!menus.length) return Promise.resolve();

    var handles = menus
      .map(function (menu) {
        return menu.getAttribute('data-handle');
      })
      .filter(Boolean);

    if (!handles.length) return Promise.resolve();

    var searchUrl = (window.T4Sroutes && window.T4Sroutes.search_url) || '/search';
    var fetchUrl =
      searchUrl +
      '?type=article&q=' +
      encodeURIComponent(handles.join(' ')) +
      '&section_id=dropdown-menu';

    function finish(html) {
      injectDropHtml(html);
      initHeaderOnce();
    }

    if (window.T4SThemeSP && typeof T4SThemeSP.getToFetchSection === 'function') {
      return T4SThemeSP.getToFetchSection(null, 'text', fetchUrl).then(finish);
    }

    return fetch(fetchUrl, { credentials: 'same-origin' })
      .then(function (res) {
        return res.text();
      })
      .then(finish);
  }

  function fetchMegaSections() {
    return fetch('/?sections=mega-menu,mega-menu2', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var combined = '';
        Object.keys(data || {}).forEach(function (key) {
          var parts = String(data[key] || '').split('[nt_mega_split1]');
          if (parts[1]) combined += parts[1];
        });
        injectMegaHtml('<div>' + combined + '</div>');
      });
  }

  function closeSiblingMenus(item) {
    var parent = item.parentElement;
    if (!parent) return;

    parent.querySelectorAll('.t4s-menu-item.is-action__hover').forEach(function (sibling) {
      if (sibling !== item) {
        hideSubMenu(sibling);
      }
    });
  }

  function showSubMenu(item) {
    closeSiblingMenus(item);
    item.classList.add('is-action__hover');

    var sub = item.querySelector(':scope > .t4s-sub-menu');
    if (sub) {
      sub.classList.remove('t4s-op-0', 't4s-pe-none');
    }

    if (item.classList.contains('t4s-type__drop')) {
      var lazyDrop = item.querySelector('.t4s-lazy_menu[data-handle]');
      if (lazyDrop && !lazyDrop.querySelector('.t4s-menu-item a')) {
        clearDropSessionCache();
        fetchDropMenus().catch(function (err) {
          console.warn('[npp-mega-menu-fix] drop menu fetch failed', err);
        });
      }
    }

    resetMegaFlexLayout();
    afterMegaUpdate();
  }

  function hideSubMenu(item) {
    item.classList.remove('is-action__hover');

    var sub = item.querySelector(':scope > .t4s-sub-menu');
    if (sub) {
      sub.classList.add('t4s-op-0', 't4s-pe-none');
    }
  }

  function bindMegaHover() {
    document
      .querySelectorAll('.t4s-navigation .t4s-nav__ul > .t4s-menu-item.has--children')
      .forEach(function (item) {
        if (item.dataset.nppMegaHoverBound === 'true') return;
        item.dataset.nppMegaHoverBound = 'true';

        item.addEventListener('mouseenter', function () {
          showSubMenu(item);
        });

        item.addEventListener('mouseleave', function (e) {
          var sub = item.querySelector(':scope > .t4s-sub-menu');
          if (sub && sub.contains(e.relatedTarget)) return;
          hideSubMenu(item);
        });
      });
  }

  function boot() {
    bindMegaHover();

    var needMega = megaMenusNeedContent();
    var needDrop = dropMenusNeedContent();

    if (needMega || needDrop) {
      if (needMega) clearMegaSessionCache();
      if (needDrop) clearDropSessionCache();

      var jobs = [];
      if (needMega) jobs.push(fetchMegaSections());
      if (needDrop) jobs.push(fetchDropMenus());

      Promise.all(jobs)
        .then(function () {
          afterMegaUpdate();
          initHeaderOnce();
        })
        .catch(function (err) {
          console.warn('[npp-mega-menu-fix] header menu fetch failed', err);
        });
      return;
    }

    afterMegaUpdate();
    initHeaderOnce();
  }

  function scheduleBoot() {
    bindMegaHover();
    boot();
    window.setTimeout(boot, 600);
    window.setTimeout(boot, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleBoot);
  } else {
    scheduleBoot();
  }
})();

